module.exports = __webpack_public_path__ + "static/media/declaration-form-step2.61c3712e.svg";